import { usePageData } from 'lib/page-data/PageDataContext';
import React from 'react';
import ArticleHeroImageBackground from './ArticleHero/ArticleHeroImageBackground';
import ArticleHeroImageRight from './ArticleHero/ArticleHeroImageRight/ArticleHeroImageRight';
import { ComponentProps } from 'lib/component-props';

type InvestmentsHeroProps = ComponentProps & {
  params: {
    imagePosition?: string;
  };
};

const InvestmentsHero: React.FC<InvestmentsHeroProps> = ({ params, rendering }) => {
  const { articleData } = usePageData('article') ?? {};

  if (!articleData) return null;

  const tagValues = {
    firstTag: articleData.contentGroup?.targetItem?.name?.value,
    badgeValue: articleData.articleTags?.targetItems?.[0]?.name.value,
  };

  return (
    <>
      {params.imagePosition === 'background' ? (
        <ArticleHeroImageBackground
          data-e2e-component-uid={rendering.uid}
          article={articleData}
          tagValues={tagValues}
        />
      ) : (
        <ArticleHeroImageRight
          data-e2e-component-uid={rendering.uid}
          article={articleData}
          tagValues={tagValues}
        />
      )}
    </>
  );
};

export default InvestmentsHero;
